import { Pipe, PipeTransform } from '@angular/core';
import { Controller } from 'src/app/core/models/controller.model';
import { Property } from 'src/app/core/models/project/property.model';

@Pipe({
  name: 'showHvacColumn',
})
export class ShowHvacColumnPipe implements PipeTransform {

  transform(controllers: Controller[], ): boolean {
    return controllers.some((cont)=> {
      return cont.controllerProperties.$values.some((prop)=> {
        return this.isHvacProp(prop) && !prop.hidden
      })
    });
  }

  private isHvacProp(prop: Property) {
    return Property.isRoomTemperatureCurrent(prop) ||
     Property.isRoomTemperatureSet(prop) ||
    Property.isHvacActive(prop) ||
    Property.isHvacHeatCool(prop) ||
    Property.isHvacHeatCoolAuto(prop) ||
    Property.isFancoilV1(prop) ||
    Property.isFancoilV2(prop) ||
    Property.isFancoilV3(prop) ||
    Property.isFancoilVAuto(prop) ||
    Property.isRoomFloorHeating(prop) ||
    Property.isBathroomFloorHeating(prop) ||
    Property.isBathroomTemperatureCurrent(prop) ||
    Property.isBathroomTemperatureSet(prop) ||
    Property.isCO2Measurement(prop) ||
    Property.isHumidity(prop) ||
    Property.isBathroomRadiator(prop) ||
    Property.isRoomRadiator(prop) ||
    Property.isRelayOutputStatus(prop) ||
    Property.isDaikinUnitOnOff(prop) ||
    Property.isDaikinUnitSetTemperature(prop) ||
    Property.isDaikinUnitMeasuredTemperature(prop) ||
    Property.isDaikinUnitStatus(prop) ||
    Property.isDaikinUnitFanSpeed(prop) ||
    Property.isDaikinUnitMode(prop) ||
    Property.isLgUnitOnOff(prop) ||
    Property.isLgUnitSetTemperature(prop) ||
    Property.isLgUnitMeasuredTemperature(prop) ||
    Property.isLgUnitStatus(prop) ||
    Property.isLgUnitFanSpeed(prop) ||
    Property.isLgUnitOperationMode(prop) ||
    Property.isBoschUnitOnOff(prop) ||
    Property.isBoschUnitSetTemperature(prop) ||
    Property.isBoschUnitMeasuredTemperature(prop) ||
    Property.isBoschUnitStatus(prop) ||
    Property.isBoschUnitFanSpeed(prop) ||
    Property.isBoschUnitOperationMode(prop) ||
    Property.isMitsubishiUnitOnOff(prop) ||
    Property.isMitsubishiUnitSetTemperature(prop) ||
    Property.isMitsubishiUnitMeasuredTemperature(prop) ||
    Property.isMitsubishiUnitStatus(prop) ||
    Property.isMitsubishiUnitFanSpeed(prop) ||
    Property.isMitsubishiUnitOperationMode(prop) ||
    Property.isHaierUnitOnOff(prop) ||
    Property.isHaierUnitSetTemperature(prop) ||
    Property.isHaierUnitMeasuredTemperature(prop) ||
    Property.isHaierUnitStatus(prop) ||
    Property.isHaierUnitFanSpeed(prop) ||
    Property.isHaierUnitOperationMode(prop) ||
    Property.isPanasonicUnitOnOff(prop) ||
    Property.isPanasonicUnitSetTemperature(prop) ||
    Property.isPanasonicUnitMeasuredTemperature(prop) ||
    Property.isPanasonicUnitStatus(prop) ||
    Property.isPanasonicUnitFanSpeed(prop) ||
    Property.isPanasonicUnitOperationMode(prop) ||
    Property.isVrvOnOff(prop) ||
    Property.isVrvSpeed(prop) ||
    Property.isMeasuredTemperature3(prop)||
    Property.fancoilMode(prop)

  }

}
